var rmUtil = require("../rmlibrary_old/util");
var StyleManager = require("../style-manager");
var PDFNode = require("./node");
var PDFBlockNode = require("./block");
var numPattern = /^\d+(\.\d+)?$/;
function PDFCanvasNode(node, pseudo, parent, content, styles, attributes) {
    PDFNode.apply(this, arguments);
    this.srcWidth = node.width;
    this.srcHeight = node.height;
    var widthAttr = attributes.width;
    var heightAttr = attributes.height;
    if (widthAttr && numPattern.test(widthAttr))
        widthAttr = Number(widthAttr);
    else
        widthAttr = undefined;
    if (heightAttr && numPattern.test(heightAttr))
        heightAttr = Number(heightAttr);
    else
        heightAttr = undefined;
    this.alt = attributes.alt || "";
    this.attr = {
        width: widthAttr,
        height: heightAttr,
        placement: attributes["pdf-placement"],
    };
    this.generateFn = node.pdfGenerate;
    this.drawCanvasHook = node.drawCanvasHook;
    Object.defineProperty(this, "dataUri", {
        get: function () {
            return this.getDataUri(this.dataType || "image/png");
        },
    });
}
rmUtil.inherits(PDFCanvasNode, PDFNode);
PDFCanvasNode.prototype.isInlineBlock = function () {
    return true;
};
PDFCanvasNode.prototype.getDataUri = function (dataType) {
    return this.originalNode.toDataURL(dataType || "image/png");
};
PDFCanvasNode.prototype.generate = function (pdf) {
    var styles = PDFBlockNode.prototype._getOptions.call(this);
    styles.verticalAlign = this.computedStyles.verticalAlign || "baseline";
    styles.paddingLeft = 0;
    styles.paddingRight = 0;
    styles.paddingTop = 0;
    styles.paddingBottom = 0;
    styles.ref = this.originalNode;
    if (this.attr.width && typeof styles.width === "undefined")
        styles.width = StyleManager.pxToPt(this.attr.width);
    if (this.attr.height && typeof styles.height === "undefined")
        styles.height = StyleManager.pxToPt(this.attr.height);
    var pdfImage;
    if (typeof this.generateFn !== "function") {
        pdfImage = pdf.image({
            width: this.computedStyles.width,
            height: this.computedStyles.height,
            srcWidth: StyleManager.pxToPt(this.srcWidth),
            srcHeight: StyleManager.pxToPt(this.srcHeight),
            src: this.dataUri,
            alt: this.alt,
            placement: this.attr.placement,
            drawHook: this.drawCanvasHook,
        });
    }
    else {
        var generateFn = this.generateFn;
        pdfImage = pdf.canvas(styles.width, styles.height, this.alt, function (doc, cursor) {
            function doIt(doc) {
                var canvas = cursor.doc.canvas;
                canvas.width = cursor.width / 0.75;
                canvas.height = cursor.height / 0.75;
                var ctx = canvas.getContext("2d");
                if (typeof ctx.setLineDash !== "function") {
                    var ctxProto = Object.getPrototypeOf(ctx);
                    var ctxProto_restore = ctxProto.restore;
                    ctxProto.restore = function () {
                        ctxProto_restore.apply(this, arguments);
                        this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset);
                    };
                    ctxProto.setLineDash = function (segments) {
                        this.ctx.lineDash = segments;
                        this.pdf.setLineDash(segments, this.ctx.lineDashOffset || 0);
                    };
                    Object.defineProperty(ctx, "lineDashOffset", {
                        get: function () {
                            return this.ctx.lineDashOffset;
                        },
                        set: function (value) {
                            this.ctx.lineDashOffset = value;
                            this.pdf.setLineDash(this.ctx.lineDash, value);
                        },
                    });
                }
                ctx.autoPaging = false;
                ctx.save();
                ctx.autoPaging = false;
                ctx.transform(0.75, 0, 0, 0.75, cursor.x, cursor.y);
                ctx.beginPath();
                ctx.rect(0, 0, cursor.width / 0.75, cursor.height / 0.75);
                ctx.closePath();
                ctx.clip();
                generateFn.call(this.originalNode, doc, cursor, canvas);
                ctx.restore();
            }
            if (doc.advancedAPI) {
                doc.advancedAPI(function (doc) { return doIt(doc); });
            }
            else {
                doIt(doc);
            }
        });
    }
    var ret;
    if (this.styles.display === "inline" || this.styles.display === "inline-block") {
        ret = pdf.inlineBlock(styles, [pdfImage]);
    }
    else if (this.styles.display === "block") {
        ret = pdf.block(styles, [pdfImage]);
    }
    if (this.href)
        ret.href = this.href;
    return ret;
};
module.exports = PDFCanvasNode;
//# sourceMappingURL=module.js.map